/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { DashboardModalActions as modal } from '@carvana/purchase-helpers';
import { getDocumentWizardConfig } from '../../document-wizard-modal-config';
import * as sc from '../../document-wizard-modal.styles';
import DocumentAlert from '../document-alert';
import DocumentSelect from '../document-select';
import DocumentPreview from '../document-preview';
import DocumentQuestionnaire from '../document-questionnaire';

const DocumentWizardModal = props => {
  const {
    modalProps: { verificationType, documentId },
    modalProps,
    requestDocuments
  } = props || {};

  const selectedDocument = requestDocuments.find(x => x.id === documentId);

  const newProps = {
    ...modalProps,
    document: selectedDocument,
    wizardConfig: getDocumentWizardConfig(verificationType, document.id)
  };

  const [currentStepNumber, setCurrentStepNumber] = useState(1);
  const { validations } = document || {};
  const showDocumentAlert =
    validations?.isScreenshot || validations?.isDuplicate;

  const goToStep = stepNumber => {
    modal.ShowModalLoadingSpinner();
    setCurrentStepNumber(stepNumber);
    modal.HideModalLoadingSpinner({ delay: 500 });
  };

  useEffect(() => {
    const stepNumber = selectedDocument.image ? 2 : 1;

    setCurrentStepNumber(stepNumber);
  }, [selectedDocument.image]);

  return (
    <sc.WizardWrapper>
      <sc.WizardProgressBar
        max="7"
        value={document.id === 1 ? currentStepNumber : currentStepNumber + 4}
      />
      {currentStepNumber === 1 ? (
        <DocumentSelect
          {...newProps}
          goToStep={() => goToStep(currentStepNumber + 1)}
        />
      ) : currentStepNumber === 2 ? (
        <sc.WizardFormsWrapper>
          <DocumentPreview
            {...newProps}
            showFileUploadForm={() => goToStep(1)}
          />
          <sc.WizardSection>
            {showDocumentAlert ? (
              <DocumentAlert
                errorType={validations?.isScreenshot ? 'screenshot' : undefined}
                goToStep={goToStep}
              />
            ) : (
              <DocumentQuestionnaire {...newProps} />
            )}
          </sc.WizardSection>
        </sc.WizardFormsWrapper>
      ) : null}
    </sc.WizardWrapper>
  );
};

export default DocumentWizardModal;
